const TimeMixin = SuperClass => class TimeUpdatable extends SuperClass {
  constructor({
    player,
    timeBucketMs = 1,
    preloadTimeMs = 0,
    ...options
  }) {
    if (typeof SuperClass.prototype.updateParams !== 'function') {
      throw new TypeError(`Invalid base class: "${SuperClass.name}" not support "updateParams" method`);
    }

    if (!player) {
      throw new TypeError(`Failed to construct TimeUpdatable class base on "${SuperClass.name}": "player" argument required`);
    }

    if (typeof player.addEventListener !== 'function' || !Object.prototype.hasOwnProperty.call(player, 'currentTime')) {
      throw new TypeError('Invalid "player" instance.');
    }

    super(options);
    this.player = player;
    this.timeBucketType = null;

    if (typeof timeBucketMs == 'string') {
      this.timeBucketType = timeBucketMs;
      timeBucketMs = this.getTimeBucketByType(this.timeBucketType, this.player.currentTime);
    }

    this.preloadTimeMs = preloadTimeMs && Math.max(preloadTimeMs, timeBucketMs);
    this.timeBucketMs = timeBucketMs;
    this.currentTimeBucket = this.getTimeBucket(this.player.currentTime);
    this.params = options.params || {};
    this.updateParams({
      time: this.currentTimeBucket
    });
    this.player.addEventListener('timeupdate', this.handleTimeUpdate.bind(this));
  }

  handleTimeUpdate(e) {
    const nextTimeBucket = this.getTimeBucket(e.target.currentTime);

    if (nextTimeBucket === this.currentTimeBucket) {
      return;
    }

    this.updateParams({
      time: nextTimeBucket
    });
    this.currentTimeBucket = nextTimeBucket;
  }

  getTimeBucket(timestamp) {
    let timeBucket = this.timeBucketMs;

    if (this.timeBucketType !== null) {
      timeBucket = this.getTimeBucketByType(this.timeBucketType, timestamp);

      if (this.timeBucketType === 'monthly') {
        return timeBucket;
      }
    }

    timeBucket = Math.floor(timestamp / timeBucket) * timeBucket;
    return timeBucket || 0;
  }

  getTimeBucketByType(type, timestamp) {
    switch (type) {
      case 'hourly':
        return 1000 * 60 * 60 * 1;

      case 'daily':
        return 1000 * 60 * 60 * 1 * 24;

      case 'monthly':
        return this.getMonthlyTimestamp(timestamp);
    }
  }

  getMonthlyTimestamp(timestamp) {
    const date = new Date(timestamp);
    const month = date.getMonth();
    const year = date.getFullYear();
    const hoursOffset = date.getTimezoneOffset() / 60;
    const time = new Date(year, month, 1, -hoursOffset).getTime();
    return time < 0 ? 0 : time;
  }

};

export default TimeMixin;